import React from "react";
import CrmSystem from "../CrmSystem";

const CrmRecentWidget = () => (
  <div className="widget-content-scroll">
    <CrmSystem />
  </div>
);

export default CrmRecentWidget;
